import { useMemo, useCallback, useState } from 'react';
import dayjs from 'dayjs';
import type { SurveyCGType } from '@/types/graphql/root';
import { useSetAtom } from 'jotai';
import { historyStackAtom } from '@/atom/historyStack';
import { usePathname } from 'next/navigation';
import { history } from '@/utils/history';

export default function useTripDates(trip: SurveyCGType | null) {
  const setHistoryStack = useSetAtom(historyStackAtom);
  const pathname = usePathname();
  const [modifySurveyDateModalVisible, setModifySurveyDateModalVisible] = useState(false);

  const startAndEndDate = useMemo(() => {
    if (!trip || !trip.fromDateTime || !trip.toDateTime) {
      return null;
    }

    const fromDate = dayjs(trip.fromDateTime).format('YY.MM.DD');
    const toDate = dayjs(trip.toDateTime).format('YY.MM.DD');
    const range = dayjs(trip.toDateTime).diff(dayjs(trip.fromDateTime), 'day');

    return {
      start: fromDate,
      end: toDate,
      range: range,
    };
  }, [trip]);

  const getDayInfo = useCallback(
    (day: number) => {
      if (!trip) return null;
      const fromDateTime = trip?.fromDateTime;
      if (!fromDateTime) return null;

      return dayjs(fromDateTime)
        .locale('ko')
        .add(day - 1, 'day')
        .format('MM.DD ddd');
    },
    [trip],
  );

  const onClickModifySurveyDate = useCallback(() => {
    setModifySurveyDateModalVisible(true);
    history?.push(pathname + '#modify-survey-date');
    setHistoryStack((prev) => [
      ...prev,
      {
        name: '일정표 날짜 변경 모달 닫기 (from client-trip-page.tsx)',
        afterAction: () => setModifySurveyDateModalVisible(false),
      },
    ]);
  }, [pathname]);

  return {
    startAndEndDate,
    getDayInfo,
    modifySurveyDateModalVisible,
    onClickModifySurveyDate,
    setModifySurveyDateModalVisible,
  };
}
